package top.wcpe.allincore.ui.runtime.host

/** JS：为刚发生的复制/剪切保留一次同步粘贴回退，其余粘贴交给 DOM 系统剪贴板事件。 */
private object MemoryClipboardSink : ClipboardSink {

    private var pendingContent: String? = null

    override fun text(): String? = pendingContent.also { pendingContent = null }

    override fun setText(text: String) {
        pendingContent = text
    }

    override fun supportsSynchronousPaste(): Boolean = pendingContent != null
}

internal actual fun clipboardSink(): ClipboardSink = MemoryClipboardSink
